import { TFormalOffers } from './formalOffers.types';
import { getDurationInMonths } from '../GetDurationInMonths/getDurationInMonths';

/**
 * Checks if the first offer in a list of formal offers has a loan duration of 6 months or less.
 *
 * @param formalOffers An array of formal offers.
 * @returns `true` if the first offer has a micro loan duration, `false` otherwise.
 */
export const getHasMicroOffer = (formalOffers: TFormalOffers): boolean => {
    if (formalOffers.length === 0) return false;
    return getDurationInMonths(formalOffers[0].duration!) <= 6;
};
